import {
  CompletedSoftCheckDataResult,
  Query,
} from '@varo/graphql-schema-types';
import { useState } from 'react';
import GetLineOfCreditSoftPullCompleteStatus from 'services/graphql/queries/GetLineOfCreditSoftPullCompleteStatus';
import { CombinedError, useQuery } from 'urql';

interface LineOfCreditSoftPullCompleteStatusResult {
  result?: CompletedSoftCheckDataResult;
  error?: CombinedError;
  fetching: boolean;
  refetchCheck: () => void;
}

const useGetLineOfCreditSoftPullCompleteStatus =
  (): LineOfCreditSoftPullCompleteStatusResult => {
    const [isPaused, setIsPaused] = useState(true);

    const [response, refetch] = useQuery<Query>({
      query: GetLineOfCreditSoftPullCompleteStatus,
      requestPolicy: 'network-only',
      pause: isPaused,
    });

    const { data, fetching, error } = response;

    const refetchCheck = () => {
      setIsPaused(false);
      refetch();
    };

    return {
      result: data?.hasCompletedSoftCheck,
      fetching,
      error,
      refetchCheck,
    };
  };

export default useGetLineOfCreditSoftPullCompleteStatus;
